import React from 'react';
import { BsInstagram, BsEnvelopeFill, BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="mailto:sohailss2412@gmail.com" target="_blank" rel="noreferrer"><BsEnvelopeFill /></a>
    </div>
    <div>
      <a href="https://linkedin.com/in/ahmadsohail404" target="_blank" rel="noreferrer"><BsLinkedin /></a>
    </div>
    <div>
      <a href="https://github.com/ahmadsohail404" target="_blank" rel="noreferrer"> <FaGithub /></a>
    </div>
    <div>
      <a href="https://instagram.com/ahmadsohail_ig" target="_blank" rel="noreferrer"><BsInstagram /></a>
    </div>
  </div>
);

export default SocialMedia;
